import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircleSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.0415 9.99996C1.0415 14.9475 5.05229 18.9583 9.99984 18.9583C14.9474 18.9583 18.9582 14.9475 18.9582 9.99996C18.9582 5.05241 14.9474 1.04163 9.99984 1.04163C5.05229 1.04163 1.0415 5.05241 1.0415 9.99996ZM13.8963 6.88567C14.2355 7.19666 14.2584 7.7238 13.9475 8.06307L9.36417 13.063C9.2105 13.2306 8.99517 13.3281 8.76792 13.3331C8.54067 13.338 8.3213 13.25 8.16058 13.0892L6.07725 11.0059C5.75181 10.6805 5.75181 10.1528 6.07725 9.82738C6.40269 9.50196 6.93032 9.50196 7.25576 9.82738L8.72367 11.2953L12.7188 6.93686C13.0298 6.59759 13.557 6.57468 13.8963 6.88567Z",
		fill: "currentColor"
	})
});
export default SvgCheckCircleSolid;
